export const DEFAULT_UUIID_EMPTY = '00000000-0000-0000-0000-000000000000';

export const SCHEDULE_DEMO_URL =
  'https://calendly.com/routix/30min?hide_gdpr_banner=1&primary_color=5618b6';

export const TRACKING_PAGE_URL = 'https://track.routix.io';

export const HELP_CENTER_URL = 'http://help.routix.io/';

export const API_DOCS_URL = process.env.REACT_APP_API_DOCS_URL ?? '';
